module.exports = __webpack_public_path__ + "img/stage-5-motion.f66111c0.png";